module.exports = __webpack_public_path__ + "img/logo_genl_blanco.7b0aa99a.png";